import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useClipboard } from '@vueuse/core'

import AttendeesList from './AttendeesList.vue'
import TripShareSection from './TripShareSection.vue'
import LButton from '@/components/core/Button.vue'
import LInput from '@/components/core/form/Input.vue'
import { useInviteUser } from '@/composables/attendee'
import { useSelectedTrip } from '@/composables/trip'
import { tripModule } from '@/store'
import { logEvent } from '@/utils/utility-manager'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripShareSectionCanEdit',
  setup(__props) {

const trip = useSelectedTrip()
const inviteLink = ref(
  `${process.env.LAMBUS_HOMEPAGE}/joinTrip/${trip.value.token.split('@')[0]}`,
)

// Invite User Functionality ---------------------------------------------------

const { mutate: inviteUser } = useInviteUser(trip.value._id)
const inviteInput = ref('')
const isInviting = ref(false)

function handleInvite() {
  const trimmedInput = inviteInput.value.trim()
  if (!trimmedInput) {
    return
  }

  isInviting.value = true
  inviteUser(trimmedInput, {
    async onSuccess() {
      inviteInput.value = ''
      logEvent('trip_share_invite_user', { method: 'email_or_username' })
      await tripModule.fetch(trip.value._id)
    },
    onSettled() {
      isInviting.value = false
    },
    onError() {
      logEvent('trip_share_invite_user_failed', { method: 'email_or_username' })
    },
  })
}

// Clipboard functionality -----------------------------------------------------

const { copied, copy } = useClipboard()

async function copyToClipboard(text: string) {
  logEvent('trip_share_invite_link_copied')
  await copy(text)
}

return { __sfc: true,trip, inviteLink, inviteUser, inviteInput, isInviting, handleInvite, copied, copy, copyToClipboard, AttendeesList, TripShareSection, LButton, LInput }
}

})